import { queryParamHookFactory } from '../../../../taboola-common-frontend-modules/query-params';

export const REPORT_FORCE_FETCH_FLAG = 'reportForceFetchFlag';

// This hook should be removed once we migrated to Report component and use invalidate query instead
export const useReportForceFetchFlag = queryParamHookFactory(REPORT_FORCE_FETCH_FLAG);
